import React, { useState } from 'react';
import {
    Warehouse, Plus, ArrowDownToLine, Send, RotateCcw,
    Recycle, PackageCheck, PackageX, X, AlertCircle,
    CheckCircle2, TrendingDown, Search, Download,
    Edit2, Trash2, ChevronRight, ChevronDown
} from 'lucide-react';
import { api } from '../api';

const STYLES = `
  .wh-root { padding: 0; }
  .wh-kpi { display: grid; grid-template-columns: repeat(4,1fr); gap: 14px; margin-bottom: 22px; }
  .wh-kc {
    background: #fff; border: 1px solid #e2e8f0; border-radius: 12px;
    padding: 18px 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  }
  .wh-kc-lbl { font-size: 10px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 6px; }
  .wh-kc-val { font-size: 26px; font-weight: 800; color: #0f172a; line-height: 1; }
  .wh-kc-sub { font-size: 11px; color: #94a3b8; margin-top: 4px; }

  .wh-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.06); margin-bottom: 18px; }
  .wh-card-hdr { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
  .wh-card-hdr h3 { margin: 0; font-size: 14px; font-weight: 700; }

  .wh-tbl { width: 100%; border-collapse: collapse; }
  .wh-tbl th { text-align: left; padding: 9px 12px; font-size: 10px; font-weight: 700; color: #94a3b8; background: #f8fafc; border-bottom: 1px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
  .wh-tbl td { padding: 11px 12px; border-bottom: 1px solid #f8fafc; font-size: 13px; color: #334155; }
  .wh-tbl tr:last-child td { border-bottom: none; }
  .wh-tbl tr.cr { cursor: pointer; transition: background 0.1s; }
  .wh-tbl tr.cr:hover td { background: #f8fafc; }

  .wh-badge { padding: 3px 8px; border-radius: 4px; font-size: 10px; font-weight: 700; text-transform: uppercase; }
  .wh-in-stock  { background: #dcfce7; color: #166534; }
  .wh-low       { background: #fef3c7; color: #92400e; }
  .wh-out       { background: #fee2e2; color: #991b1b; }

  .wh-pb { height: 4px; background: #f1f5f9; border-radius: 2px; overflow: hidden; margin-top: 3px; }
  .wh-pf { height: 100%; border-radius: 2px; }

  .wh-action { background: none; border: 1px solid #e2e8f0; padding: 4px 8px; border-radius: 5px; cursor: pointer; font-size: 11px; font-family: 'Plus Jakarta Sans',sans-serif; font-weight: 600; display: inline-flex; align-items: center; gap: 4px; transition: all 0.12s; }
  .wh-action:hover { background: #f1f5f9; }
  .wh-action.dispatch { color: #1d4ed8; border-color: #bfdbfe; }
  .wh-action.dispatch:hover { background: #eff6ff; }
  .wh-action.return   { color: #16a34a; border-color: #bbf7d0; }
  .wh-action.return:hover   { background: #f0fdf4; }
  .wh-action.scrap    { color: #dc2626; border-color: #fecaca; }
  .wh-action.scrap:hover    { background: #fef2f2; }

  .wh-site-row { background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 7px; padding: 8px 12px; margin-bottom: 6px; display: flex; align-items: center; gap: 10px; font-size: 12px; }
  .wh-site-name { font-weight: 700; flex: 1; color: #0f172a; }
  .wh-site-chip { padding: 2px 8px; border-radius: 4px; font-size: 10px; font-weight: 700; }

  .wh-mov-type { padding: 2px 8px; border-radius: 4px; font-size: 10px; font-weight: 700; }
  .wh-mov-inward   { background: #dcfce7; color: #166534; }
  .wh-mov-dispatch { background: #eff6ff; color: #1d4ed8; }
  .wh-mov-return   { background: #fef3c7; color: #92400e; }
  .wh-mov-scrap    { background: #fee2e2; color: #991b1b; }

  .wh-moverlay { position: fixed; inset: 0; background: rgba(15,23,42,0.5); display: flex; align-items: center; justify-content: center; z-index: 2000; backdrop-filter: blur(5px); }
  .wh-mbox { background: #fff; border-radius: 14px; padding: 0; width: 100%; max-width: 500px; box-shadow: 0 24px 48px rgba(0,0,0,0.18); border: 1px solid #e2e8f0; max-height: 90vh; overflow-y: auto; }
  .wh-mhdr { padding: 20px 24px 16px; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center; }
  .wh-mhdr h2 { margin: 0; font-size: 15px; font-weight: 800; }
  .wh-mbody { padding: 20px 24px 24px; }
  .wh-mcls { background: #f1f5f9; border: none; cursor: pointer; padding: 5px; border-radius: 7px; display: flex; color: #64748b; }
  .wh-mcls:hover { background: #e2e8f0; color: #0f172a; }

  .wh-fg { margin-bottom: 13px; }
  .wh-fg label { display: block; font-size: 11px; font-weight: 700; margin-bottom: 4px; color: #374151; text-transform: uppercase; letter-spacing: 0.4px; }
  .wh-fg input, .wh-fg select, .wh-fg textarea { width: 100%; padding: 9px 11px; border: 1.5px solid #e2e8f0; border-radius: 8px; font-size: 13px; outline: none; font-family: 'Plus Jakarta Sans',sans-serif; background: #fff; transition: border-color 0.12s; }
  .wh-fg input:focus, .wh-fg select:focus { border-color: #1d4ed8; box-shadow: 0 0 0 3px #eff6ff; }
  .wh-grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 11px; }
  .wh-btn { display: inline-flex; align-items: center; gap: 6px; padding: 9px 18px; border-radius: 8px; font-weight: 700; cursor: pointer; font-size: 13px; font-family: 'Plus Jakarta Sans',sans-serif; border: none; transition: all 0.13s; }
  .wh-btn-primary { background: #1d4ed8; color: #fff; }
  .wh-btn-primary:hover { background: #1e40af; }
  .wh-btn-ghost { background: #f8fafc; color: #64748b; border: 1px solid #e2e8f0; }

  .wh-expand-row td { background: #fafbfc !important; }
  .wh-tabs { display: flex; gap: 4px; margin-bottom: 18px; background: #f8fafc; padding: 4px; border-radius: 9px; border: 1px solid #e2e8f0; width: fit-content; }
  .wh-tab { padding: 7px 16px; border: none; background: transparent; font-size: 12px; font-weight: 600; color: #64748b; cursor: pointer; border-radius: 6px; font-family: 'Plus Jakarta Sans',sans-serif; transition: all 0.12s; }
  .wh-tab.active { background: #fff; color: #1d4ed8; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
`;

export default function WarehouseTab({ warehouse, indents, projects, user, onRefresh, showToast }) {
    const [tab,         setTab]         = useState('stock');
    const [search,      setSearch]      = useState('');
    const [modal,       setModal]       = useState(null); // 'inward'|'dispatch'|'return'|'scrap'|'add'
    const [selectedItem, setSelectedItem] = useState(null);
    const [expandedId,  setExpandedId]  = useState(null);
    const [saving,      setSaving]      = useState(false);
    const [movements,   setMovements]   = useState([]);
    const [loadingMov,  setLoadingMov]  = useState(false);

    const openModal = (type, item = null) => { setSelectedItem(item); setModal(type); };
    const closeModal = () => { setModal(null); setSelectedItem(null); };

    const fetchMovements = async () => {
        setLoadingMov(true);
        try {
            const m = await api('warehouse/movements');
            setMovements(Array.isArray(m) ? m : []);
        } catch { showToast('Could not load movements.'); }
        setLoadingMov(false);
    };

    const handleTabChange = (t) => {
        setTab(t);
        if (t === 'movements' && movements.length === 0) fetchMovements();
    };

    const doSubmit = async (e, type) => {
        e.preventDefault();
        const f = new FormData(e.target);
        setSaving(true);
        try {
            await api('warehouse', 'POST', {
                type,
                warehouse_id:  selectedItem?.id,
                material:   f.get('material')   || selectedItem?.material,
                category:   f.get('category')   || 'General',
                unit:       f.get('unit')        || selectedItem?.unit,
                qty:        parseFloat(f.get('qty') || 0),
                min_stock:  parseFloat(f.get('min_stock') || 0),
                project:    f.get('project')     || '',
                site:       f.get('site')        || f.get('project') || '',
                indent_id:  f.get('indent_id')   || null,
                notes:      f.get('notes')       || '',
                by_user:    user?.name           || 'Admin',
            });
            await onRefresh();
            closeModal();
            showToast(
                type === 'inward'   ? 'Stock received into warehouse.' :
                type === 'dispatch' ? 'Material dispatched to site.' :
                type === 'return'   ? 'Material returned to warehouse.' :
                'Scrap logged.'
            );
        } catch (err) {
            showToast(err.message || 'Error saving.');
        }
        setSaving(false);
    };

    const doDelete = async (id) => {
        if (!window.confirm('Remove this material from warehouse?')) return;
        try { await api(`warehouse/${id}`, 'DELETE'); await onRefresh(); showToast('Removed.'); }
        catch { showToast('Error.'); }
    };

    // KPIs
    const totalItems   = warehouse.length;
    const inStock      = warehouse.filter(g => g.status === 'In Stock').length;
    const lowStock     = warehouse.filter(g => g.status === 'Low Stock').length;
    const outOfStock   = warehouse.filter(g => g.status === 'Out of Stock').length;
    const pendingInds  = indents.filter(i => i.status === 'Pending' || i.status === 'Approved').length;

    // Total material at sites
    const totalAtSites = warehouse.reduce((acc, g) =>
        acc + (g.sites || []).reduce((a, s) => a + (s.at_site || 0), 0), 0
    );
    const totalScrap   = warehouse.reduce((acc, g) =>
        acc + (g.sites || []).reduce((a, s) => a + (s.scrapped || 0), 0), 0
    );

    const sq     = search.toLowerCase();
    const fItems = warehouse.filter(g =>
        g.material?.toLowerCase().includes(sq) ||
        g.category?.toLowerCase().includes(sq)
    );

    const pendingApprovedIndents = indents.filter(i =>
        i.status === 'Approved' || i.status === 'Pending'
    );

    return (
        <>
        <style>{STYLES}</style>
        <div className="wh-root">

            {/* KPI strip */}
            <div className="wh-kpi">
                <div className="wh-kc" style={{borderTop:'3px solid #1d4ed8'}}>
                    <div className="wh-kc-lbl">Total Materials</div>
                    <div className="wh-kc-val">{totalItems}</div>
                    <div className="wh-kc-sub">{inStock} in stock · {lowStock} low</div>
                </div>
                <div className="wh-kc" style={{borderTop:`3px solid ${outOfStock>0?'#ef4444':'#10b981'}`}}>
                    <div className="wh-kc-lbl">Out of Stock</div>
                    <div className="wh-kc-val" style={{color:outOfStock>0?'#ef4444':'#10b981'}}>{outOfStock}</div>
                    <div className="wh-kc-sub">Needs replenishment</div>
                </div>
                <div className="wh-kc" style={{borderTop:'3px solid #f59e0b'}}>
                    <div className="wh-kc-lbl">At Sites</div>
                    <div className="wh-kc-val">{Math.round(totalAtSites)}</div>
                    <div className="wh-kc-sub">Units across all sites</div>
                </div>
                <div className="wh-kc" style={{borderTop:`3px solid ${pendingInds>0?'#f59e0b':'#94a3b8'}`}}>
                    <div className="wh-kc-lbl">Pending Indents</div>
                    <div className="wh-kc-val" style={{color:pendingInds>0?'#f59e0b':'#94a3b8'}}>{pendingInds}</div>
                    <div className="wh-kc-sub">Awaiting approval / dispatch</div>
                </div>
            </div>

            {/* Tabs */}
            <div className="wh-tabs">
                {[['stock','📦 Stock Register'],['sites','🏗 At Sites & Scrap'],['pending','⏳ Pending Indents'],['movements','📋 Movement Log']].map(([t,l])=>(
                    <button key={t} className={`wh-tab ${tab===t?'active':''}`} onClick={()=>handleTabChange(t)}>{l}</button>
                ))}
            </div>

            {/* ── STOCK REGISTER ── */}
            {tab === 'stock' && (
                <div className="wh-card">
                    <div className="wh-card-hdr">
                        <h3>Warehouse Stock Register</h3>
                        <div style={{display:'flex',gap:'8px'}}>
                            <div style={{position:'relative'}}>
                                <Search size={13} style={{position:'absolute',left:'9px',top:'50%',transform:'translateY(-50%)',color:'#94a3b8'}}/>
                                <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search material…"
                                    style={{padding:'7px 12px 7px 28px',border:'1px solid #e2e8f0',borderRadius:'7px',fontSize:'12px',outline:'none',width:'180px',fontFamily:'Plus Jakarta Sans,sans-serif'}}/>
                            </div>
                            <button className="wh-btn wh-btn-primary" onClick={()=>openModal('inward')}>
                                <ArrowDownToLine size={13}/> Receive Stock
                            </button>
                        </div>
                    </div>

                    <table className="wh-tbl">
                        <thead>
                            <tr>
                                <th></th><th>Material</th><th>Category</th><th>Unit</th>
                                <th>Total Received</th><th>Dispatched</th><th>Available</th>
                                <th>Min Stock</th><th>Status</th><th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fItems.map(g => (<>
                                <tr key={g.id} className="cr" onClick={()=>setExpandedId(expandedId===g.id?null:g.id)}>
                                    <td style={{width:'30px',textAlign:'center'}}>
                                        {expandedId===g.id ? <ChevronDown size={13} color="#94a3b8"/> : <ChevronRight size={13} color="#94a3b8"/>}
                                    </td>
                                    <td style={{fontWeight:'700'}}>{g.material}</td>
                                    <td style={{fontSize:'11px',color:'#64748b'}}>{g.category}</td>
                                    <td>{g.unit}</td>
                                    <td style={{fontWeight:'600'}}>{g.total_qty}</td>
                                    <td>{g.dispatched}</td>
                                    <td style={{fontWeight:'800',color:g.available<=0?'#dc2626':g.available<=g.min_stock?'#d97706':'#0f172a'}}>
                                        {g.available}
                                        <div className="wh-pb"><div className="wh-pf" style={{width:`${Math.min(100,(g.available/Math.max(g.total_qty,1))*100)}%`,background:g.available<=0?'#ef4444':g.available<=g.min_stock?'#f59e0b':'#10b981'}}/></div>
                                    </td>
                                    <td style={{color:'#94a3b8'}}>{g.min_stock||'—'}</td>
                                    <td>
                                        <span className={`wh-badge ${g.status==='In Stock'?'wh-in-stock':g.status==='Low Stock'?'wh-low':'wh-out'}`}>
                                            {g.status}
                                        </span>
                                    </td>
                                    <td onClick={e=>e.stopPropagation()} style={{display:'flex',gap:'5px',flexWrap:'wrap'}}>
                                        <button className="wh-action dispatch" onClick={()=>openModal('dispatch',g)}><Send size={10}/> Dispatch</button>
                                        <button className="wh-action return" onClick={()=>openModal('return',g)}><RotateCcw size={10}/> Return</button>
                                        <button className="wh-action scrap" onClick={()=>openModal('scrap',g)}><Recycle size={10}/> Scrap</button>
                                        <button className="wh-action" style={{color:'#dc2626',borderColor:'#fecaca'}} onClick={()=>doDelete(g.id)}><Trash2 size={10}/></button>
                                    </td>
                                </tr>
                                {expandedId===g.id && (
                                    <tr className="wh-expand-row">
                                        <td colSpan="10" style={{padding:'0 12px 12px 40px'}}>
                                            <div style={{fontSize:'11px',fontWeight:'700',color:'#94a3b8',textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:'8px'}}>Site Breakdown</div>
                                            {(g.sites||[]).length === 0
                                                ? <span style={{fontSize:'12px',color:'#94a3b8'}}>Not dispatched to any site yet.</span>
                                                : (g.sites||[]).map((s,i) => (
                                                    <div key={i} className="wh-site-row">
                                                        <span className="wh-site-name">{s.site}</span>
                                                        <span className="wh-site-chip" style={{background:'#eff6ff',color:'#1d4ed8'}}>At site: {s.at_site} {g.unit}</span>
                                                        <span className="wh-site-chip" style={{background:'#f0fdf4',color:'#166534'}}>Returned: {s.returned} {g.unit}</span>
                                                        <span className="wh-site-chip" style={{background:'#fee2e2',color:'#991b1b'}}>Scrap: {s.scrapped} {g.unit}</span>
                                                    </div>
                                                ))
                                            }
                                        </td>
                                    </tr>
                                )}
                            </>))}
                            {fItems.length === 0 && (
                                <tr><td colSpan="10" style={{textAlign:'center',padding:'40px',color:'#94a3b8'}}>
                                    No materials in warehouse. Click "Receive Stock" to add.
                                </td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ── AT SITES & SCRAP ── */}
            {tab === 'sites' && (
                <div className="wh-card">
                    <div className="wh-card-hdr">
                        <h3>Materials at Sites &amp; Scrap Report</h3>
                        <div style={{fontSize:'12px',color:'#64748b',background:'#fef3c7',border:'1px solid #fde68a',borderRadius:'6px',padding:'5px 12px',fontWeight:'600'}}>
                            Total Scrap: {Math.round(totalScrap)} units
                        </div>
                    </div>
                    <table className="wh-tbl">
                        <thead>
                            <tr><th>Material</th><th>Unit</th><th>Site</th><th>At Site</th><th>Returned</th><th>Scrap</th><th>Net Pending</th></tr>
                        </thead>
                        <tbody>
                            {warehouse.filter(g=>(g.sites||[]).length>0).flatMap(g =>
                                (g.sites||[]).map((s,i) => (
                                    <tr key={`${g.id}-${i}`}>
                                        <td style={{fontWeight:'700'}}>{g.material}</td>
                                        <td>{g.unit}</td>
                                        <td style={{fontWeight:'600',color:'#1d4ed8'}}>{s.site}</td>
                                        <td style={{fontWeight:'700'}}>{s.at_site}</td>
                                        <td style={{color:'#16a34a',fontWeight:'600'}}>{s.returned}</td>
                                        <td style={{color:'#dc2626',fontWeight:'600'}}>{s.scrapped}</td>
                                        <td style={{fontWeight:'800',color:s.at_site-s.returned>0?'#d97706':'#16a34a'}}>
                                            {Math.max(0, s.at_site - s.returned)}
                                        </td>
                                    </tr>
                                ))
                            )}
                            {warehouse.filter(g=>(g.sites||[]).length>0).length === 0 && (
                                <tr><td colSpan="7" style={{textAlign:'center',padding:'40px',color:'#94a3b8'}}>No materials dispatched to sites yet.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ── PENDING INDENTS ── */}
            {tab === 'pending' && (
                <div className="wh-card">
                    <div className="wh-card-hdr">
                        <h3>Pending Indents — Ready to Dispatch</h3>
                    </div>
                    <table className="wh-tbl">
                        <thead>
                            <tr><th>Indent ID</th><th>Site</th><th>Material</th><th>Qty</th><th>Priority</th><th>Status</th><th>Action</th></tr>
                        </thead>
                        <tbody>
                            {pendingApprovedIndents.map(ind => (
                                <tr key={ind.id}>
                                    <td style={{fontWeight:'800',color:'#1d4ed8'}}>{ind.id}</td>
                                    <td style={{fontWeight:'600'}}>{ind.project}</td>
                                    <td>{(ind.items||[])[0]?.item || ind.item}</td>
                                    <td>{(ind.items||[])[0]?.qty || ind.qty} {(ind.items||[])[0]?.uom || ind.uom}</td>
                                    <td>
                                        <span style={{fontSize:'11px',fontWeight:'700',color:ind.priority==='Urgent'?'#dc2626':ind.priority==='High'?'#d97706':'#64748b'}}>
                                            {ind.priority}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`wh-badge ${ind.status==='Approved'?'wh-in-stock':'wh-low'}`}>{ind.status}</span>
                                    </td>
                                    <td>
                                        {ind.status === 'Approved' && (
                                            <button className="wh-action dispatch" onClick={()=>{
                                                // Pre-fill dispatch modal with indent details
                                                const matchedItem = warehouse.find(g =>
                                                    g.material.toLowerCase().includes(((ind.items||[])[0]?.item || ind.item || '').toLowerCase().split(' ')[0])
                                                );
                                                openModal('dispatch', { ...matchedItem, _indent: ind });
                                            }}>
                                                <Send size={10}/> Dispatch from Warehouse
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {pendingApprovedIndents.length === 0 && (
                                <tr><td colSpan="7" style={{textAlign:'center',padding:'40px',color:'#94a3b8'}}>No pending indents.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ── MOVEMENT LOG ── */}
            {tab === 'movements' && (
                <div className="wh-card">
                    <div className="wh-card-hdr">
                        <h3>Movement History</h3>
                        <button className="wh-btn wh-btn-ghost" onClick={fetchMovements} style={{fontSize:'12px'}}>Refresh</button>
                    </div>
                    {loadingMov ? (
                        <div style={{textAlign:'center',padding:'40px',color:'#94a3b8'}}>Loading…</div>
                    ) : (
                        <table className="wh-tbl">
                            <thead>
                                <tr><th>Date</th><th>Material</th><th>Type</th><th>Qty</th><th>Site / Project</th><th>By</th><th>Notes</th></tr>
                            </thead>
                            <tbody>
                                {movements.map(m => (
                                    <tr key={m.id}>
                                        <td style={{fontSize:'11px',color:'#94a3b8'}}>{m.created_at?.split(' ')[0]}</td>
                                        <td style={{fontWeight:'600'}}>{m.material}</td>
                                        <td>
                                            <span className={`wh-mov-type wh-mov-${m.type}`}>
                                                {m.type === 'inward' ? '⬇ Inward' : m.type === 'dispatch' ? '⬆ Dispatch' : m.type === 'return' ? '↩ Return' : '🗑 Scrap'}
                                            </span>
                                        </td>
                                        <td style={{fontWeight:'700'}}>{m.qty} {m.unit}</td>
                                        <td>{m.site || m.project || '—'}</td>
                                        <td style={{fontSize:'11px',color:'#64748b'}}>{m.by_user}</td>
                                        <td style={{fontSize:'11px',color:'#94a3b8',maxWidth:'160px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{m.notes}</td>
                                    </tr>
                                ))}
                                {movements.length === 0 && (
                                    <tr><td colSpan="7" style={{textAlign:'center',padding:'40px',color:'#94a3b8'}}>No movements recorded yet.</td></tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </div>

        {/* ── MODALS ── */}

        {/* Receive Stock (Inward) */}
        {modal === 'inward' && (
            <div className="wh-moverlay">
                <div className="wh-mbox">
                    <div className="wh-mhdr">
                        <h2>⬇ Receive Stock into Warehouse</h2>
                        <button className="wh-mcls" onClick={closeModal}><X size={16}/></button>
                    </div>
                    <div className="wh-mbody">
                        <form onSubmit={e=>doSubmit(e,'inward')}>
                            <div className="wh-fg"><label>Material Name *</label><input name="material" placeholder="e.g. Cement OPC 53 Grade" required/></div>
                            <div className="wh-grid2">
                                <div className="wh-fg"><label>Category</label>
                                    <select name="category">
                                        {['Cement','Steel','Aggregates','Bricks & Blocks','Plumbing','Electrical','Paints','Safety Equipment','Tools','Other'].map(c=><option key={c}>{c}</option>)}
                                    </select>
                                </div>
                                <div className="wh-fg"><label>Unit</label>
                                    <select name="unit">
                                        {['Bags','Tons','Units','Litres','m³','Metres','Rolls','Pieces','Trucks'].map(u=><option key={u}>{u}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="wh-grid2">
                                <div className="wh-fg"><label>Quantity Received *</label><input name="qty" type="number" min="0.01" step="0.01" placeholder="0" required/></div>
                                <div className="wh-fg"><label>Min Stock Level</label><input name="min_stock" type="number" min="0" step="0.01" placeholder="Alert below this qty"/></div>
                            </div>
                            <div className="wh-fg"><label>Supplier / Notes</label><input name="notes" placeholder="e.g. Ambuja Cements invoice #1234"/></div>
                            <button type="submit" className="wh-btn wh-btn-primary" style={{width:'100%',padding:'11px'}} disabled={saving}>
                                {saving ? 'Saving…' : <><ArrowDownToLine size={14}/> Receive into Warehouse</>}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        )}

        {/* Dispatch to Site */}
        {modal === 'dispatch' && selectedItem && (
            <div className="wh-moverlay">
                <div className="wh-mbox">
                    <div className="wh-mhdr">
                        <h2>⬆ Dispatch to Site</h2>
                        <button className="wh-mcls" onClick={closeModal}><X size={16}/></button>
                    </div>
                    <div className="wh-mbody">
                        <div style={{background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:'9px',padding:'12px 14px',marginBottom:'14px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <div>
                                <div style={{fontWeight:'700',fontSize:'14px'}}>{selectedItem.material}</div>
                                <div style={{fontSize:'11px',color:'#64748b',marginTop:'2px'}}>{selectedItem.category}</div>
                            </div>
                            <div style={{textAlign:'right'}}>
                                <div style={{fontWeight:'800',fontSize:'18px',color:'#1d4ed8'}}>{selectedItem.available}</div>
                                <div style={{fontSize:'10px',color:'#94a3b8'}}>{selectedItem.unit} available</div>
                            </div>
                        </div>
                        {selectedItem.available <= 0 && (
                            <div style={{background:'#fef2f2',border:'1px solid #fecaca',borderRadius:'8px',padding:'10px 13px',marginBottom:'14px',fontSize:'12px',color:'#dc2626',fontWeight:'600',display:'flex',gap:'7px',alignItems:'center'}}>
                                <AlertCircle size={14}/> Out of stock — cannot dispatch.
                            </div>
                        )}
                        <form onSubmit={e=>doSubmit(e,'dispatch')}>
                            <div className="wh-fg">
                                <label>Dispatch to Site *</label>
                                <select name="project" required defaultValue={selectedItem._indent?.project || ''}>
                                    <option value="">-- Select Site --</option>
                                    {projects.map(p=><option key={p.id} value={p.name}>{p.name}</option>)}
                                </select>
                            </div>
                            <div className="wh-fg">
                                <label>Quantity to Dispatch *</label>
                                <input name="qty" type="number" min="0.01" max={selectedItem.available} step="0.01"
                                    defaultValue={selectedItem._indent ? ((selectedItem._indent.items||[])[0]?.qty || selectedItem._indent.qty) : ''}
                                    placeholder="0" required/>
                            </div>
                            {selectedItem._indent && (
                                <input type="hidden" name="indent_id" value={selectedItem._indent.id}/>
                            )}
                            <div className="wh-fg"><label>Notes</label><input name="notes" placeholder="Dispatch reference / vehicle no."/></div>
                            <button type="submit" className="wh-btn wh-btn-primary" style={{width:'100%',padding:'11px',background:'#1d4ed8'}} disabled={saving||selectedItem.available<=0}>
                                {saving ? 'Dispatching…' : <><Send size={14}/> Dispatch to Site</>}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        )}

        {/* Return from Site */}
        {modal === 'return' && selectedItem && (
            <div className="wh-moverlay">
                <div className="wh-mbox">
                    <div className="wh-mhdr">
                        <h2>↩ Return to Warehouse</h2>
                        <button className="wh-mcls" onClick={closeModal}><X size={16}/></button>
                    </div>
                    <div className="wh-mbody">
                        <form onSubmit={e=>doSubmit(e,'return')}>
                            <div style={{background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:'8px',padding:'10px 13px',marginBottom:'14px',fontSize:'12px',color:'#166534',fontWeight:'600'}}>
                                Returning: <strong>{selectedItem.material}</strong>
                            </div>
                            <div className="wh-fg">
                                <label>Returning from Site *</label>
                                <select name="project" required>
                                    <option value="">-- Select Site --</option>
                                    {(selectedItem.sites||[]).map((s,i)=><option key={i} value={s.site}>{s.site} (at site: {s.at_site} {selectedItem.unit})</option>)}
                                    {projects.map(p=><option key={p.id} value={p.name}>{p.name}</option>)}
                                </select>
                            </div>
                            <div className="wh-fg"><label>Quantity Returned *</label><input name="qty" type="number" min="0.01" step="0.01" placeholder="0" required/></div>
                            <div className="wh-fg"><label>Notes</label><input name="notes" placeholder="Reason for return / condition"/></div>
                            <button type="submit" className="wh-btn wh-btn-primary" style={{width:'100%',padding:'11px',background:'#16a34a'}} disabled={saving}>
                                {saving ? 'Saving…' : <><RotateCcw size={14}/> Return to Warehouse</>}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        )}

        {/* Log Scrap */}
        {modal === 'scrap' && selectedItem && (
            <div className="wh-moverlay">
                <div className="wh-mbox">
                    <div className="wh-mhdr">
                        <h2>🗑 Log Scrap Material</h2>
                        <button className="wh-mcls" onClick={closeModal}><X size={16}/></button>
                    </div>
                    <div className="wh-mbody">
                        <form onSubmit={e=>doSubmit(e,'scrap')}>
                            <div style={{background:'#fef2f2',border:'1px solid #fecaca',borderRadius:'8px',padding:'10px 13px',marginBottom:'14px',fontSize:'12px',color:'#dc2626',fontWeight:'600',display:'flex',gap:'7px'}}>
                                <AlertCircle size={14}/> Scrap is irreversible — material is written off permanently.
                            </div>
                            <div style={{background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:'8px',padding:'10px 13px',marginBottom:'14px',fontWeight:'700'}}>
                                {selectedItem.material}
                            </div>
                            <div className="wh-fg">
                                <label>At Site (where scrap occurred) *</label>
                                <select name="project" required>
                                    <option value="">-- Select Site --</option>
                                    {(selectedItem.sites||[]).map((s,i)=><option key={i} value={s.site}>{s.site}</option>)}
                                    {projects.map(p=><option key={p.id} value={p.name}>{p.name}</option>)}
                                </select>
                            </div>
                            <div className="wh-fg"><label>Scrap Quantity *</label><input name="qty" type="number" min="0.01" step="0.01" placeholder="0" required/></div>
                            <div className="wh-fg"><label>Reason for Scrap</label><input name="notes" placeholder="e.g. Damaged during transit, expired"/></div>
                            <button type="submit" className="wh-btn wh-btn-primary" style={{width:'100%',padding:'11px',background:'#dc2626'}} disabled={saving}>
                                {saving ? 'Saving…' : <><Recycle size={14}/> Log Scrap</>}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        )}
        </>
    );
}
